<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{$route.meta.title}}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>财务管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :show-header="false">
      <el-table ref="multipleTable"
                :data="table"
                stripe
                highlight-current-row
                style="width: 100%">
        <el-table-column prop="userid"
                         label="用户ID"></el-table-column>
        <el-table-column prop="realname"
                         label="用户姓名"></el-table-column>
        <el-table-column prop="cellphone"
                         label="用户手机"></el-table-column>
        <el-table-column prop="balance"
                         label="账户余额"></el-table-column>
        <el-table-column prop="updatetime"
                         label="最后操作时间"></el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import table from '@core/mixins/table'

export default {
  mixins: [table],
  data () {
    return {
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0,
      },
    }
  },
  computed: Vuex.mapState({}),
  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     *
     */
    getTableData (params) {
      return request.page('inactiveUserList', params)
    },
  },
}
</script>


<style lang="scss"
       scoped>
</style>



// WEBPACK FOOTER //
// src/views/finance/pages/InactiveUserTable.vue